<script setup>
import { onMounted, ref } from 'vue';
import { useSettingsStore } from '@/stores/settingsStore';

const storeSettings = useSettingsStore();

onMounted( async () => {
})
</script>
<template>
    <footer class="footer section" >
        <div class="container footer__container" data-animation-bottom>
            <div class="footer__top">
                <div class="footer__logo">
                    <a href="#wrapper" class="logo --footer"><img loading='lazy' width="200" height="64" src="@/assets/img/icons/logo.svg" alt="логотип"></a>
                    <span>We are explorers</span>
                </div>
                <div class="footer__info">
                    <ul class="footer__list">
                        <li>Контакты</li>
                        <li><a :href="`tel:${storeSettings.contactsPhone}`">{{ storeSettings.contactsPhone }}</a></li>
                        <li><a :href="`mailto:${storeSettings.contactsEmail}`">{{ storeSettings.contactsEmail }}</a></li>
                    </ul>
                    <ul class="footer__list">
                        <li>Режим работы</li>
                        <li v-for="item, index in storeSettings.contactsWorkTime" :key="index"> {{ item }}</li>
                    </ul>
                    <ul class="footer__list">
                        <li>Адрес</li>
                        <li>{{ storeSettings.contactsAddress }}</li>
                    </ul>
                </div>
            </div>
            <div class="footer__bottom">
                <span>The Rink Fitness © Все права защищены</span>
                <div class="footer__bottom-links">

                    <div class="footer__links">
                        <a :href="storeSettings.offer" target="_blank">Оферта</a>
                        <a :href="storeSettings.rules" target="_blank">Правила клуба</a>
                        <a :href="storeSettings.policy_personal_data" target="_blank">Обработка персональных данных</a>
                    </div>
                    <a href="https://lucky-site.com/" target="_blank" class="footer__logo-web">
                        <span>Разработка сайта</span>
                        <img class='' width='78' height='38' src='@/assets/img/icons/logo_lucky.svg' alt='изображение логотипа'>
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>
<style lang='scss' scoped>
</style>